var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"svg-icon-component",class:{ 'svg-icon-align-middle': _vm.alignMiddle },attrs:{"width":_vm.width,"height":_vm.height},on:{"click":function($event){return _vm._triggerClickEvent()}}},[_c('img',{attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }